import type { MRT_RowData, MRT_TableInstance } from 'material-react-table'
import { Typography } from '@mui/material'
import {
    formatTableTotals,
    getTableTotals,
    type TableTotalsLabels,
} from '../../util/table-totals'

export interface TableTotalsLineProps<TData extends MRT_RowData> {
    table: MRT_TableInstance<TData>
    getValue: (row: TData) => number
    labels: TableTotalsLabels
    // How many rows exist upstream, when that can be more than were loaded.
    available?: number
}

export const TableTotalsLine = <TData extends MRT_RowData>({
    table,
    getValue,
    labels,
    available,
}: TableTotalsLineProps<TData>) => {
    const isFiltered = table.getState().columnFilters.length > 0
    const totals = getTableTotals(
        table.getCoreRowModel().rows,
        isFiltered ? table.getFilteredRowModel().rows : undefined,
        (row) => getValue(row.original),
    )

    return (
        <Typography variant="body2" sx={{ alignSelf: 'center' }}>
            {formatTableTotals(totals, labels, available)}
        </Typography>
    )
}
